import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RichTextComment, Thread, Threads, TimelineItem } from "../timeline-item";
import Delta from "quill-delta";
import { TaskActionContentDTO } from '../../taskbook-triage/taskbook.types';

@Injectable({
  providedIn: 'root'
})
export class ThreadService {

  constructor(
    private httpClient: HttpClient,
  ) {}

  addThread(timelineItemId: string, itemType: string, message: RichTextComment, isAnonymous: boolean): Observable<TimelineItem & Threads> {
    const addThread = new AddThreadDTO(timelineItemId, itemType, message, isAnonymous);
    return this.httpClient.put<TimelineItem & Threads>('/api/timeline/' + itemType + '/' + timelineItemId + '/thread/', addThread);
  }

  updateThread(timelineItemId: string, itemType: string, thread: Thread): Observable<TimelineItem & Threads> {
    return this.httpClient.put<TimelineItem & Threads>('/api/timeline/' + itemType + '/' + timelineItemId + '/thread/' + thread.id, {
      message: thread.message.objectModelFormat,
      anonymity: thread.isAnonymous,
      timelineItemId: timelineItemId,
      itemType: itemType,
    });
  }

  deleteThread(timelineItemId: string, itemType: string, threadId: string): Observable<TimelineItem & Threads> {
    return this.httpClient.delete<TimelineItem & Threads>('/api/timeline/' + itemType + '/' + timelineItemId + '/thread/' + threadId);
  }

  moderateThread(timelineItemId: string, itemType: string, threadId: string, reason: string): Observable<TimelineItem & Threads> {
    return this.httpClient
      .put<TimelineItem & Threads>('/api/timeline/' + itemType + '/' + timelineItemId + '/moderation/thread/' + threadId, { reason: reason });
  }
}

export class AddThreadDTO implements TaskActionContentDTO {
    id: string = "addThread";
    timelineItemId: string;
    itemType: string;
    message: Delta;
    anonymity: boolean;

    constructor(timelineItemId: string, itemType: string, message: RichTextComment, isAnonymous: boolean) {
      this.timelineItemId = timelineItemId;
      this.itemType = itemType;
      this.message = message.objectModelFormat;
      this.anonymity = isAnonymous;
    }
}

export class ManagerCommentDTO implements TaskActionContentDTO {
  id: string = "managerComment";
  comment: {
    timelineItemId: string;
    itemType: string;
    message: Delta;
    anonymity: boolean;
  }

  constructor(timelineItemId: string, itemType: string, message: RichTextComment, isAnonymous: boolean) {
    this.comment = {
      timelineItemId: timelineItemId,
      itemType: itemType,
      message: message.objectModelFormat,
      anonymity: isAnonymous
    }
  }
}

